(() => {
  const dlg = document.querySelector('[data-kabelvraag]');
  if (!dlg) return;

  const SLEUTEL = 'vt-kabelvraag';
  const root = window.Shopify?.routes?.root || '/';
  const kabelIds = new Set((dlg.dataset.kabel || '').split(',').filter(Boolean).map(Number));

  const leesJson = (kiezer, terug) => {
    try { return JSON.parse(dlg.querySelector(kiezer)?.textContent || ''); } catch { return terug; }
  };
  const T = leesJson('[data-kv-teksten]', {});
  const KABELS = leesJson('[data-kv-kabels]', []);
  const zin = (t, w) => Object.entries(w).reduce((uit, [k, v]) => uit.split(`[${k}]`).join(v), t || '');

  const $ = (k) => dlg.querySelector(k);
  const ja = $('[data-kv-ja]');
  const fout = $('[data-kv-fout]');
  const stappen = [...dlg.querySelectorAll('[data-kv-stap]')];
  const autoStap = $('[data-kv-stap="auto"]');
  const kiesMerk = autoStap?.querySelector('[data-fit-merk]');
  const kiesModel = autoStap?.querySelector('[data-fit-model]');
  const go = $('[data-kv-go]');
  const autoMelding = $('[data-kv-melding]');
  const kabelMelding = $('[data-kv-kabelmelding]');
  const advies = $('[data-kv-advies]');
  const zelfkeuze = $('[data-kv-zelfkeuze]');
  const uitv = window.VTKabel?.uitvoeringVeld(autoStap?.querySelector('[data-uitvoering]'));

  let wacht = null;

  const zeiNee = () => {
    try { return sessionStorage.getItem(SLEUTEL) === 'nee'; } catch { return false; }
  };
  const onthoudNee = () => {
    try { sessionStorage.setItem(SLEUTEL, 'nee'); } catch {  }
  };

  const isPaalFormulier = (form) =>
    form.matches('form[action*="/cart/add"]') &&
    (form.getAttribute('id') === 'vt-koop' || form.matches('[data-sticky-form]')) &&
    form.dataset.geenLade !== 'true';

  function regelUit(data) {
    const regel = { id: Number(data.get('id')), quantity: Math.max(1, Number(data.get('quantity')) || 1) };
    const eigen = {};
    for (const [k, v] of data.entries()) {
      const m = /^properties\[(.+)\]$/.exec(k);
      if (m && typeof v === 'string') eigen[m[1]] = v;
    }
    if (Object.keys(eigen).length) regel.properties = eigen;
    return regel;
  }

  async function post(body, json) {
    const r = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: json ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: json ? JSON.stringify(body) : body,
    });
    if (!r.ok) throw new Error('toevoegen mislukt');
    const uit = await r.json();
    return uit?.items?.[0] || uit;
  }

  const naarLade = (regel) =>
    document.dispatchEvent(new CustomEvent('vt:lade', { detail: { soort: 'toegevoegd', regel } }));

  async function alleenPaal(w) {
    try {
      naarLade(await post(w.data, false));
    } catch {
      w.form.dataset.geenLade = 'true';
      w.form.submit();
    }
  }

  function naarStap(naam, focus) {
    stappen.forEach((st) => { st.hidden = st.dataset.kvStap !== naam; });
    focus?.focus?.({ preventScroll: true });
  }

  function melding(el, tekst) {
    if (!el) return;
    el.textContent = tekst || '';
    el.hidden = !tekst;
  }

  function zetKnop() {
    const gekozen = dlg.querySelector('[data-kv-kabel]:checked');
    ja.disabled = !gekozen;
    ja.textContent = gekozen ? ja.dataset.klaar : ja.dataset.kies;
  }

  function zetSoort() {
    const soort = dlg.querySelector('[data-kv-soort]:checked')?.value;
    dlg.querySelectorAll('[data-kv-kabelvak]').forEach((vak) => {
      const aan = vak.dataset.kvKabelvak === soort;
      vak.hidden = !aan;
      if (!aan) vak.querySelectorAll('[data-kv-kabel]').forEach((r) => { r.checked = false; });
    });
    zetKnop();
  }

  function kiesSoort(id) {
    const r = dlg.querySelector(`[data-kv-soort][value="${id}"]`);
    if (r) r.checked = true;
    zetSoort();
  }

  function toonAdvies(auto, b) {
    $('[data-kv-advies-auto]').textContent = zin(T.advies, { auto: auto.volnaam || auto.naam || '' });
    $('[data-kv-advies-kabel]').textContent = b.kabel.titel;
    const kw = Math.round(b.levert * 10) / 10;
    $('[data-kv-advies-levert]').textContent = kw ? zin(T.levert, { kw: kw.toLocaleString(document.documentElement.lang || undefined) }) : '';
    advies.hidden = false;
    zelfkeuze.hidden = true;
    melding(kabelMelding, '');
    kiesSoort(b.kabel.id);
    naarStap('kabel', dlg.querySelector('[data-kv-kabelvak]:not([hidden]) [data-kv-kabel]:not(:disabled)'));
  }

  function naarZelf(reden) {
    advies.hidden = true;
    zelfkeuze.hidden = false;
    melding(kabelMelding, reden);
    if (!dlg.querySelector('[data-kv-soort]:checked')) {
      kiesSoort((dlg.querySelector('[data-kv-favoriet]') || dlg.querySelector('[data-kv-soort]'))?.value);
    }
    naarStap('kabel', dlg.querySelector('[data-kv-soort]:checked'));
  }

  let catalogus = null;

  function laadCatalogus() {
    if (catalogus) return Promise.resolve(catalogus);
    return window.VTCatalogus.laad().then((c) => { catalogus = c; return c; });
  }

  function vulModellen(merk) {
    const modellen = (catalogus || {})[merk] || [];
    kiesModel.innerHTML = '';
    const leeg = document.createElement('option');
    leeg.value = '';
    leeg.textContent = merk ? kiesModel.dataset.leeg || '' : kiesModel.dataset.eerst || '';
    kiesModel.appendChild(leeg);
    modellen.forEach((m, i) => {
      const o = document.createElement('option');
      o.value = String(i);
      o.textContent = window.VTKabel ? VTKabel.modelLabel(m) : m.naam;
      o.dataset.naam = m.naam;
      kiesModel.appendChild(o);
    });
    kiesModel.disabled = modellen.length === 0;
  }

  const gekozenModel = () => ((catalogus || {})[kiesMerk.value] || [])[parseInt(kiesModel.value, 10)] || null;

  kiesMerk?.addEventListener('change', () => {
    melding(autoMelding, '');
    uitv?.verberg();
    vulModellen(kiesMerk.value);
  });

  kiesModel?.addEventListener('change', () => {
    melding(autoMelding, '');
    const m = gekozenModel();
    if (!m || !window.VTKabel || !uitv) return;
    const a = VTKabel.analyseerModel(m);
    if (a.vraag) uitv.toon(m, a);
    else uitv.verberg();
  });

  go?.addEventListener('click', () => {
    if (!kiesMerk.value || kiesModel.value === '') {
      (kiesMerk.value ? kiesModel : kiesMerk).focus();
      return;
    }
    const m = gekozenModel();
    if (!m || !window.VTKabel) return naarZelf(T.geen_advies);
    const a = VTKabel.analyseerModel(m);
    let auto = a.auto;
    if (a.vraag) {
      const keuze = uitv?.select.value;
      if (!keuze) {
        melding(autoMelding, T.kies_uitvoering);
        uitv?.select.focus();
        return;
      }
      auto = VTKabel.autoVoor(m, a, keuze);
    }
    if (!auto || VTKabel.isType1(auto.aansluiting)) return naarZelf(T.geen_advies);
    const b = VTKabel.beste(auto, KABELS);
    if (!b) return naarZelf(T.geen_advies);
    toonAdvies(auto, b);
  });

  function open(w) {
    wacht = w;
    dlg.querySelectorAll('[data-kv-kabel], [data-kv-soort]').forEach((r) => { r.checked = false; });
    zetSoort();
    advies.hidden = true;
    zelfkeuze.hidden = true;
    melding(autoMelding, '');
    melding(kabelMelding, '');
    fout.hidden = true;
    naarStap('vraag');
    window.VtDialoog.open(dlg);
    bereidAutoVoor();
  }

  function sluitMet() {
    const w = wacht;
    wacht = null;
    window.VtDialoog.sluit(dlg);
    return w;
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!isPaalFormulier(form) || zeiNee()) return;
    if (!window.VtDialoog) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const w = { form, data: new FormData(form) };
    const knop = form.querySelector('[type="submit"]');
    if (knop) knop.disabled = true;

    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('wagen'))))
      .then((wagen) => {
        const heeftKabel = (wagen.items || []).some((i) => kabelIds.has(Number(i.product_id)));
        return heeftKabel ? alleenPaal(w) : open(w);
      })
      .catch(() => alleenPaal(w))
      .finally(() => { if (knop) knop.disabled = false; });
  }, true);

  dlg.addEventListener('change', (e) => {
    if (e.target.matches('[data-kv-soort]')) zetSoort();
    if (e.target.matches('[data-kv-kabel]')) {
      fout.hidden = true;
      zetKnop();
    }
  });

  let autoKlaar = false;
  function bereidAutoVoor() {
    if (autoKlaar || !go) return;
    go.disabled = true;
    go.setAttribute('aria-busy', 'true');
    laadCatalogus()
      .then(() => {
        autoKlaar = true;
        go.disabled = false;
        go.removeAttribute('aria-busy');
        if (kiesMerk.value) vulModellen(kiesMerk.value);
      })
      .catch(() => {
        go.removeAttribute('aria-busy');
        if (!autoStap.hidden) naarZelf('');
      });
  }

  $('[data-kv-wel]')?.addEventListener('click', () => {
    const eerste = autoStap.querySelector('[data-kz]')?.dataset.modus === 'kenteken'
      ? autoStap.querySelector('[data-kz-plaat]') : kiesMerk;
    naarStap('auto', eerste);
    if (!autoKlaar) bereidAutoVoor();
  });

  $('[data-kv-zelf]')?.addEventListener('click', () => naarZelf(''));

  dlg.querySelectorAll('[data-kv-modus]').forEach((l) => l.addEventListener('click', () => {
    melding(autoMelding, '');
    autoStap.querySelector(`[data-kz-tab="${l.dataset.kvModus}"]`)?.click();
    const doel = l.dataset.kvModus === 'kenteken' ? autoStap.querySelector('[data-kz-plaat]') : kiesMerk;
    setTimeout(() => doel?.focus({ preventScroll: true }), 50);
  }));
  $('[data-kv-andere]')?.addEventListener('click', () => naarStap('auto', go));

  ja.addEventListener('click', async () => {
    const kabel = dlg.querySelector('[data-kv-kabel]:checked');
    if (!kabel || !wacht) return;
    ja.disabled = true;
    dlg.classList.add('is-bezig');
    try {
      const regel = await post({ items: [regelUit(wacht.data), { id: Number(kabel.value), quantity: 1 }] }, true);
      sluitMet();
      naarLade(regel);
    } catch {
      fout.hidden = false;
      zetKnop();
    } finally {
      dlg.classList.remove('is-bezig');
    }
  });

  dlg.querySelectorAll('[data-kv-nee]').forEach((nee) => nee.addEventListener('click', () => {
    onthoudNee();
    const w = sluitMet();
    if (w) alleenPaal(w);
  }));

  $('[data-kv-sluit]')?.addEventListener('click', () => window.VtDialoog.sluit(dlg));
  dlg.addEventListener('close', () => {
    if (!wacht) return;
    const w = wacht;
    wacht = null;
    onthoudNee();
    alleenPaal(w);
  });
})();
